import React from 'react'
import { useGlobalContext } from './context';

const Stories = () => {
  const{hits, isLoading, removePost}  = useGlobalContext();

  if(isLoading){
    return (
    <>
    <h1>Loading...</h1>
    </>
    );
  }
  return (
    <>
    <h2>My tech news Post</h2>
    {hits.map((curPost)=>{
      const {title, author, objectID, url, num_comments } = curPost;
      return (
      <div className="card" key={objectID}>
          <h2>{title}</h2>
          <p>By <span>{author}</span> | Comments :  <span>{num_comments}</span></p>
          <div className="card_button">
            <a className="rm" href={url} target="_blank">
              Read More
            </a>
            <a href="#" onClick={() => removePost(objectID)} className="remove">Remove</a>
          </div>
        </div>
      );
    })}
    </>
  );
}
export default Stories;